import type { SVGProps } from 'react'

export const RightCircleIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M400-280q-14 0-23.5-9T367-313q0-7 2.5-13t7.5-11l153-159-153-159q-5-5-7.5-11t-2.5-13q0-14 9.5-23.5T400-702q7 0 13.5 3t11.5 9l168 178q4 4 5.5 8.5T600-494q0 5-1.5 9.5T593-476L425-298q-5 6-11 9t-14 3Z" />
    </svg>
  )
}
